import { EuiCard, EuiSpacer, EuiText } from "@elastic/eui";
import { ProductDetails } from "../../api/entities/Product";
import { FC } from "react";
import { GetDiscountPrice } from "../../utils/ProductUtils";

export interface IProductDetailsCard {
  productDetails: ProductDetails;
  discount?: number;
  isOverrideSetupFee?: boolean;
  overrideSetupFee: number;
}

export const ProductDetailsCard: FC<IProductDetailsCard> = (props) => {
  const discountedPrice = GetDiscountPrice(
    props.productDetails.pricePerMonth,
    props.discount ?? 0,
  );

  return (
    <EuiCard
      title={props.productDetails.name}
      description={props.productDetails.description}
      style={{ width: 600 }}
    >
      <EuiSpacer />
      <EuiText>${props.isOverrideSetupFee ? props.overrideSetupFee : props.productDetails.setupFee} setup fee</EuiText>
      <EuiText>
        ${discountedPrice} / month for{" "}
        {props.productDetails.contractLengthMonths} months
      </EuiText>
    </EuiCard>
  );
};
